import { useDetectGPU } from "@react-three/drei";
import { extend, useFrame } from "@react-three/fiber";
import { useControls } from "leva";
import { useEffect, useMemo, useRef } from "react";
import { Chaos } from "./Chaos";
import { Depth, Fresnel, LayerMaterial, Normal } from "lamina";
import CustomLayer from "../CustomLayer";

extend({ Chaos });
extend({ CustomLayer });

const ChaosMaterial = (props) => {
  const GPU = useDetectGPU();
  const chaos = useRef();
  const custom = useRef();

  const { amplitude, detail, speed, dimensionality } = useControls(
    `${props.name} Sphere`,
    {
      amplitude: {
        value: 0.2,
        min: 0,
        max: 1,
        step: 0.05,
      },
      detail: {
        value: 0.35,
        min: 0,
        max: 1,
        step: 0.05,
      },
      speed: {
        value: 0.2,
        min: 0,
        max: 2,
        step: 0.1,
      },
      dimensionality: {
        value: 2,
        min: 0,
        max: 3,
        step: 1,
      },
    }
  );

  const {
    light1Intensity,
    light2Intensity,
    light1Color,
    light2Color,
    highlightColor,
  } = useControls(`${props.name} Lighting`, {
    light1Intensity: {
      value: 0.7,
      min: 0,
      max: 1,
      step: 0.01,
    },
    light2Intensity: {
      value: 0.7,
      min: 0,
      max: 1,
      step: 0.01,
    },
    light1Color: "#acdcf0",
    light2Color: "#fcd7e4",
    highlightColor: "#f6f5e8",
  });

  const { lacunarity, gain, colorA, colorB, cloudTint } = useControls(
    `Chaos`,
    {
      lacunarity: {
        value: 3,
        min: 0,
        max: 5,
        step: 0.1,
      },
      gain: {
        value: 0.4,
        min: 0,
        max: 1,
        step: 0.05,
      },
      colorA: {
        value: "#ffffff",
      },
      colorB: {
        value: "#2eafed",
      },
      cloudTint: {
        value: "#436ce8",
      },
    }
  );

  const resolution = useMemo(() => {
    switch (GPU.tier) {
      case 3: {
        return GPU.isMobile ? 300 : 450;
      }
      case 2: {
        return GPU.isMobile ? 200 : 300;
      }
      case 1: {
        return GPU.isMobile ? 150 : 256;
      }
      default: {
        return GPU.isMobile ? 100 : 128;
      }
    }
  }, [GPU]);

  // useEffect(() => {
  //   ref.current.geometry.computeTangents();
  // }, []);

  useFrame(({ clock }) => {
    // if (ref.current) {
    //   ref.current.material.uTime =
    //     (clock.elapsedTime * 0.25 * speed) / Math.max(dimensionality - 1, 1.0);
    // }
    chaos.current.Time =
      (clock.elapsedTime * 0.25 * speed) / Math.max(dimensionality - 1, 1.0);
    // custom.current.time =
    //    (clock.elapsedTime * 0.25 * speed) / Math.max(dimensionality - 1, 1.0);
  });

  return (
    <LayerMaterial
      color={"#dddddd"}
      lighting={"physical"} //
      // transmission={1}
      roughness={1}
      thickness={3}
      metalness={0.1}
      transparent={true}
      alpha={0.9}
    >
      <chaos
        ref={chaos}
        Time={0}
        Amp={amplitude / Math.max(dimensionality - 1, 1.0)}
        // Detail={0.1}
        Detail={(detail * 0.15) / Math.max(dimensionality - 1, 1.0)}
        Resolution={[resolution, resolution]}
        Color={"#000000"}
        FresnelColor={"#FFFF00"}
        Light2Color={light2Color}
        Light1Color={light1Color}
        FbmOctaves={dimensionality}
        LightIntensity={[light1Intensity, light2Intensity]}

        lacunarity={lacunarity}
        gain={gain}
        colorA={colorA}
        colorB={colorB}
        cloudTint={cloudTint}
      />

      <Normal mode={"multiply"} alpha={0.7} transparent={true}></Normal>
      {/* <Depth
        near={0.0}
        far={0.3}
        origin={[-0.49, 0.425, 0]}
        colorA={"#fec5da"}
        colorB={"#00b8fe"}
        mode={"multiply"}
        transparent={true}
        alpha={0.4}
      /> */}
      <Fresnel
       color={"#fefefe"}
       bias={-0.343}
       intensity={3.899}
       power={13.369}
       factor={1.119}
       mode={"screen"}
      />
    </LayerMaterial>
  );
};

export default ChaosMaterial;
